const typedKeys = Object.keys as <T extends object>(obj: T) => (keyof T)[];

export default typedKeys;
